import angular from 'angular';
import uiRouter from 'angular-ui-router';
import checkComponent from './check.component';

let checkModule = angular.module('check', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newCheck', {
            url: '/checks/new',
            component: 'check',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editCheck', {
            url: '/checks/:id',
            component: 'check',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                check: (ChecksService, $stateParams) => {
                    return ChecksService.findById($stateParams.id, {
                        include: ['client', {
                            relation: 'paymentItem'
                        }]
                    });
                }
            }
        });
})
.component('check', checkComponent)
.name;

export default checkModule;
